import React, { Component } from 'react';
import { Col, Card, CardBody, CardFooter} from 'reactstrap';
import EirColourSelector from '../colour-selector/EirColourSelector';
import DeviceNotification from '../eir-device-notification/DeviceNotification';
import EirButton from '../eir-button/EirButton';
import AspectRatioContainer from '../aspect-ratio-container/AspectRatioContainer'
import FormattedPrice from '../formatted-price/FormattedPrice';
import EirValidImage from '../eir-valid-image/EirValidImage';

class EirDeviceListing extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedVariant: null
    };
  }

  getInitialSelectedVariant() {

    for (let i = 0; i < this.props.device.variants.length; i++) {
      if (this.props.device.variants[i].inStock) {
        return this.props.device.variants[i];
      }
    }
      
    return this.props.device.variants[0];
  }

  setSelectedVariant = selectedVariant => {
    this.setState({ selectedVariant: selectedVariant });
  };

  getImageURL(selectedVariant) {
    if (selectedVariant.image.path == '') {
      for (var i = 0; i < this.props.device.variants.length; i++) {
        if (this.props.device.variants[i].image.path != '') {
          return this.props.device.variants[i].image.path;
        } else {
          return '';
        }
      }
    } else {
      return selectedVariant.image.path;
    }
  }

  getSelectedVariant(){
      return (this.state.selectedVariant || this.getInitialSelectedVariant());
  }

  render() {
    console.log('props>>',this.props);
    return (
      <Col lg="4" xs="6">
        
        <Card className="eir-device-listing eir-card mb-4 mb-md-5 mb-lg-6" >
          
          <CardBody className="eir-card-body">
            
            <a href={this.props.device.url} className="d-block pl-3 pr-3 pb-2 pl-md-4 pr-md-4 pb-md-3">
              <AspectRatioContainer xs="10-16" >  
                <EirValidImage className="img-fluid" src={this.getImageURL(this.getSelectedVariant())} fallbackSrc='/.galleries/eir/devices/handset_not_found.png' />
              </AspectRatioContainer>
            </a>

            <div className="d-flex justify-content-between">  
              <h6 className="text-left text-uppercase text-base-gray mb-md-3">{this.props.device.manufacturer}</h6>
              <h6 className="text-right text-uppercase text-danger mb-md-3">{this.state.selectedVariant == null ? this.getInitialSelectedVariant().stockStatus : this.state.selectedVariant.stockStatus}</h6>
            </div>
            
            <h4 className="text-left text-black mb-md-4">{this.props.device.model}</h4>

            <div className="d-flex flex-column flex-sm-row justify-content-between">
              <EirColourSelector colourOptions={this.props.device.variants} selectedColour={this.getSelectedVariant()} details={false} onColourSelected={this.setSelectedVariant} />
              <FormattedPrice className="text-right" fromPrice={this.props.device.fromPrice} price={this.props.device.price} />
            </div>

            <DeviceNotification device={this.props.device} selectedVariant={this.getSelectedVariant()} />

          </CardBody>

          <CardFooter className="eir-card-footer">
            
            <EirButton
              color="primary"
              outline={true}
              type="button"
              text={this.props.ctaText}
              name="Select Phone"
              link={this.props.device.url}
              className="eir-text-secondary btn-sm d-md-none"
            />

            <EirButton
              color="primary"
              outline={true}
              type="button"
              text={this.props.ctaText}
              name="Select Phone"
              link={this.props.device.url}
              className="eir-text-secondary d-none d-md-inline-block"
            />

          </CardFooter>
          
        </Card>

      </Col>
    );
  }
}

export default EirDeviceListing;
